import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { EMPTY, throwError, of } from 'rxjs';
import { map, catchError, exhaustMap, switchMap, withLatestFrom } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { WorkbookService } from '@workbook/workbook.service';
import * as WorkbookActions from '@workbook/store/workbook.actions';
import { errorTypes } from '@workbook/store/workbook.reducer';

@Injectable()
export class WorkbookEffects {
  loadViews$ = createEffect(() => this.actions$.pipe(
    ofType(WorkbookActions.getViews),
    exhaustMap(({workbookId}) => this.workbookService.getViews(workbookId).pipe(
      map(params => WorkbookActions.viewsLoaded({views: params})),
      catchError((err) => of(WorkbookActions.failRequest(
        {error: err, errorType: errorTypes.creating}
      )))
    ))
  ));

  defaultView$ = createEffect(() => this.actions$.pipe(
    ofType(WorkbookActions.getDefaultView),
    exhaustMap((action) => this.workbookService.getDefaultView(action.workbookId).pipe(
      map(view => WorkbookActions.defaultViewLoaded({view: view})),
      catchError((err) => of(WorkbookActions.failRequest(
        {error: err, errorType: errorTypes.creating}
      )))
    ))
  ));

  setOpeningType$ = createEffect(() => this.actions$.pipe(
    ofType(WorkbookActions.setOpeningType),
    exhaustMap((action) => this.workbookService.setOpeningType(action.workbookId, action.openAs).pipe(
      map((res: boolean) => WorkbookActions.setOpeningTypeResponse({success: res})),
      catchError((err) => of(WorkbookActions.failRequest(
        {error: err, errorType: errorTypes.creating}
      )))
    ))
  ));

  getWorkbook$ = createEffect(() => this.actions$.pipe(
    ofType(WorkbookActions.getWorkbook),
    exhaustMap((action) => this.workbookService.getWorkbook(action.workbookId).pipe(
      map(wb => WorkbookActions.getWorkbookSuccess({row: wb})),
      catchError((err) => of(WorkbookActions.failRequest(
        {error: err, errorType: errorTypes.creating}
      )))
    ))
  ));

  constructor(
    private actions$: Actions,
    private workbookService: WorkbookService,
  ) { }
}
